import { getTranslationKey } from 'helpers/texting';

import { findPostalCodeCountry } from './postalCodeCountries';
import { getPostalCodeFormat, isValidPostalCode } from './postalCodeRules';

export const getPostalCodeError = (
  zipCode: unknown,
  countryId?: string | null
): string | undefined => {
  if (typeof zipCode !== 'string' || !zipCode.trim()) {
    return undefined;
  }

  const country = findPostalCodeCountry(countryId);
  const format = getPostalCodeFormat(country?.code);

  // No sample for this country (or the list has not loaded yet) — never block the customer on a
  // format we cannot vouch for.
  if (!format || isValidPostalCode(zipCode, format)) {
    return undefined;
  }

  if (format.digits) {
    return getTranslationKey('shop.forms.maxLengthError', { amount: format.digits });
  }

  return getTranslationKey('shop.forms.zipcodeFormat', {
    country: country?.name || format.isoCode,
    example: format.example
  });
};
